<template>
  <v-layout column style="width: 100%">
    <list-edition-toolbar
      class="align-end"
      :buttons="toolbarButtons"
      @add="startEditingItem(null, 'create')"
    />

    <card-text
      :edition-disabled="editionDisabled"
      :textContent="editedText"
      @editItem="startEditingItem($event, 'edit')"
      @removeItem="tryRemoveItem"
    />

    <edit-content-item
      v-if="itemEditionDialog"
      :open="itemEditionDialog"
      :original-item="itemToEdit"
      :item-index="itemIndex"
      :stored-items="originalChecklistItems"
      @close="closeItemEdition"
      @add="addItem"
      @edit="editItem"
    />

    <app-dialog-box
      :open="itemDeleteDialog"
      :title="$t('DeleteItem')"
      :content="$t('DeleteConfirmation') + ' ' + itemToEdit.label + '?'"
      :main-action-label="$t('No')"
      @mainAction="itemDeleteDialog = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="removeItem"
    />
  </v-layout>
</template>

<script>
import { mapActions } from "vuex";
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import editContentItem from "./TextListItemEdit";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import CardText from "./CardText.vue";

export default {
  name: "ContentText",

  components: {
    AppDialogBox,
    editContentItem,
    ListEditionToolbar,
    CardText
  },

  props: {
    task: {
      type: Object,
      required: true
    },
    editionDisabled: {
      type: Boolean
    },
  },

  data() {
    return {
      itemEditionDialog: false,
      itemDeleteDialog: false,
      editedText: [],
      itemIndex: -1,
      newItem: {
        label: null,
        index: null,
        type: null,
        required: true,
        value: false
      },
      itemToEdit: {}
    };
  },

  computed: {
    toolbarButtons() {
      return [
        {
          id: "add",
          icon: "add_circle",
          tooltip: this.$i18n.t("AddItem"),
          active: true,
          disabled: this.editionDisabled
        }
      ];
    },

    originalChecklistItems() {
      if (this.task.hasOwnProperty("content")) {
        return this.task.content;
      }
      return this.task;
    }
  },

  mounted() {
    this.setUpData();
  },

  methods: {
    ...mapActions(["updateTask"]),

    setUpData() {
      this.editedText = Array.from(this.originalChecklistItems);
    },

    openEditingDialog() {
      this.itemEditionDialog = true;
    },

    addItem(newItem) {
      this.$emit("addItems", newItem);
    },

    startEditingItem(item, actionType) {
      if (actionType === "edit") {
        this.itemIndex = this.editedText.indexOf(item);
        this.itemToEdit = Object.assign({}, item);
      } else {
        this.itemToEdit = this.newItem;
      }

      this.openEditingDialog();
    },

    editItem(editedItem) {
      this.$emit("editItems", editedItem, this.itemIndex);
      this.editedText.splice(this.itemIndex, 1, editedItem);
    },

    tryRemoveItem(itemToDelete) {
      this.itemToEdit = itemToDelete;
      this.itemDeleteDialog = true;
    },

    removeItem() {
      const index = this.editedText.indexOf(this.itemToEdit);
      this.editedText.splice(index, 1);
      this.$emit("removeItem", index, this.itemToEdit.uuid);
      this.itemToEdit = {};
      this.itemDeleteDialog = false;
    },

    closeItemEdition() {
      this.itemEditionDialog = false;
      this.itemToEdit = {};
      this.itemIndex = -1;
    }
  },

  watch: {
    originalChecklistItems() {
      this.setUpData();
    }
  }
};
</script>

<style scoped>
.align-end {
  display: flex;
  justify-content: end;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Text/ContentText.vue